module.exports = __webpack_public_path__ + "4fb7d29f214725502cd92854c9546670.patt";